module.exports = __webpack_public_path__ + "static/media/CF_WebIcons_SpouseProgram_Watch.12f38013.svg";